(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sock-series-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.sock-series-cross-sell:not([data-upsell-ready])');

    const normalize = (value) => String(value ?? '').trim().toLowerCase();

    const selectedSize = (scope) => {
      const selectors = Array.from(scope.querySelectorAll('.single-option-selector[data-index]'));
      const sizeSelector = selectors.find((item) => {
        const name = normalize(item.dataset.optionName);
        return name.includes('velič') || name.includes('size');
      }) || (selectors.length === 1 ? selectors[0] : null);
      if (sizeSelector) return String(sizeSelector.value || '').trim();
      return String(scope.querySelector('.swatch-element:not(.color) input:checked')?.value || '').trim();
    };

    const preservePreviewParameters = (url) => {
      const currentUrl = new URL(window.location.href);
      ['pb', '_fd'].forEach((key) => {
        if (currentUrl.searchParams.has(key)) url.searchParams.set(key, currentUrl.searchParams.get(key));
      });

      let previewThemeId = currentUrl.searchParams.get('preview_theme_id');
      const theme = window.Shopify?.theme;
      const role = normalize(theme?.role);
      if (!previewThemeId && theme?.id && (role === 'unpublished' || role === 'development')) {
        previewThemeId = String(theme.id);
      }
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
    };

    const publish = (eventName, payload) => {
      const detail = {
        experiment_id: 'pdp_post_cta_cro_v2',
        placement: 'post_primary_cta',
        locale: document.documentElement.lang || '',
        market_host: window.location.host,
        ...payload
      };

      if (!Array.isArray(window.dataLayer)) window.dataLayer = [];
      window.dataLayer.push({ event: eventName, ...detail });
      document.dispatchEvent(new CustomEvent(`drfuss:${eventName}`, { detail }));

      const analytics = window.Shopify?.analytics;
      if (analytics && typeof analytics.publish === 'function') {
        const result = analytics.publish(`drfuss:${eventName}`, detail);
        if (result && typeof result.catch === 'function') result.catch(() => {});
      }
    };

    const parseVariants = (group) => {
      try {
        return JSON.parse(group.querySelector('[data-target-variants]')?.textContent || '[]');
      } catch (error) {
        console.warn('[sock-series-cross-sell] Invalid target variants', error);
        return [];
      }
    };

    const matchingVariant = (variants, size) => {
      if (!size) return null;
      const normalizedSize = normalize(size);
      return variants.find((variant) => variant.available && (variant.options || []).some((option) => normalize(option) === normalizedSize)) || null;
    };

    const decorateGroupLinks = (group, productSection) => {
      const size = selectedSize(productSection);
      const targetVariant = matchingVariant(parseVariants(group), size);
      group.querySelectorAll('[data-upsell-product-link]').forEach((link) => {
        if (!link.dataset.baseHref) link.dataset.baseHref = link.getAttribute('href') || link.href;
        const url = new URL(link.dataset.baseHref, window.location.origin);
        url.searchParams.delete('variant');
        if (targetVariant) url.searchParams.set('variant', targetVariant.id);
        preservePreviewParameters(url);
        url.searchParams.set('upsell_source', 'pdp_post_cta_cro_v2');
        url.searchParams.set('upsell_target', group.dataset.targetHandle || link.dataset.targetHandle || '');
        link.href = url.toString();
        link.dataset.sizePreserved = size ? String(Boolean(targetVariant)) : 'not-selected';
        link.dataset.targetVariantAvailable = targetVariant ? String(Boolean(targetVariant.available)) : 'unknown';
      });
      return targetVariant;
    };

    sections.forEach((section) => {
      section.dataset.upsellReady = 'true';
      const cartRoot = window.Shopify?.routes?.root || '/';
      const productSection = document.querySelector('[data-section-type="product"]') || document;
      const croTreatment = section.dataset.croTreatment === 'true';

      if (croTreatment) {
        const groups = Array.from(section.querySelectorAll('[data-upsell-link-group]'));
        const decorateAllLinks = () => groups.forEach((group) => decorateGroupLinks(group, productSection));

        groups.forEach((group) => {
          group.querySelectorAll('[data-upsell-product-link]').forEach((link) => {
            link.addEventListener('click', () => {
              const targetVariant = decorateGroupLinks(group, productSection);
              publish('pdp_color_product_click', {
                product_handle: section.dataset.currentHandle || '',
                target_product_handle: group.dataset.targetHandle || link.dataset.targetHandle || '',
                target_color: group.dataset.targetColor || '',
                selected_size: selectedSize(productSection),
                target_variant_id: targetVariant?.id ? String(targetVariant.id) : '',
                target_variant_available: targetVariant ? String(Boolean(targetVariant.available)) : 'unknown'
              });
            });
          });
        });

        decorateAllLinks();
        productSection.addEventListener('change', () => window.requestAnimationFrame(decorateAllLinks));

        let impressionTracked = false;
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            if (impressionTracked || !entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= .25)) return;
            impressionTracked = true;
            publish('pdp_color_upsell_view', {
              product_handle: section.dataset.currentHandle || '',
              selected_size: selectedSize(productSection)
            });
            observer.disconnect();
          }, { threshold: [.25] });
          observer.observe(section);

          const visibilityObserver = new IntersectionObserver((entries) => {
            const visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= .08);
            document.documentElement.classList.toggle('pdp-cro-upsell-visible', visible);
          }, { threshold: [0, .08] });
          visibilityObserver.observe(section);
        }
      }

      section.querySelectorAll('[data-upsell-card]').forEach((card) => {
        const button = card.querySelector('[data-upsell-add]');
        const status = card.querySelector('[data-upsell-status]');
        const targetVariants = parseVariants(card);
        const defaultVariantId = Number(button.dataset.defaultVariantId);

        button.addEventListener('click', async () => {
          const productFormVariant = productSection.querySelector('form[action*="/cart/add"] input[name="id"]');
          const currentVariantId = Number(productFormVariant?.value);
          const size = selectedSize(productSection);
          const targetVariant = matchingVariant(targetVariants, size)
            || targetVariants.find((variant) => variant.available && Number(variant.id) === defaultVariantId)
            || targetVariants.find((variant) => variant.available);

          if (!currentVariantId || !targetVariant) {
            status.textContent = section.dataset.errorLabel;
            if (croTreatment) {
              publish('pdp_color_bundle_add_error', {
                product_handle: section.dataset.currentHandle || '',
                target_product_handle: button.dataset.targetHandle || '',
                target_color: button.dataset.targetColor || '',
                selected_size: size,
                reason: 'variant_unavailable'
              });
            }
            return;
          }

          button.disabled = true;
          const originalLabel = button.textContent.trim();
          button.textContent = section.dataset.addingLabel;
          status.textContent = '';

          if (croTreatment) {
            publish('pdp_color_bundle_add_click', {
              product_handle: section.dataset.currentHandle || '',
              current_variant_id: String(currentVariantId),
              target_product_handle: button.dataset.targetHandle || '',
              target_color: button.dataset.targetColor || '',
              target_variant_id: String(targetVariant.id),
              selected_size: size
            });
          }

          try {
            const response = await fetch(`${cartRoot}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [
                  {
                    id: currentVariantId,
                    quantity: 1,
                    properties: { _DrFuss_paket: 'Glavni odabrani paket' }
                  },
                  {
                    id: Number(targetVariant.id),
                    quantity: 1,
                    properties: { _DrFuss_dodatak: 'Međusobni upsell serija' }
                  }
                ]
              })
            });
            if (!response.ok) throw new Error('Cart add failed');
            if (croTreatment) {
              publish('pdp_color_bundle_add_success', {
                product_handle: section.dataset.currentHandle || '',
                current_variant_id: String(currentVariantId),
                target_product_handle: button.dataset.targetHandle || '',
                target_color: button.dataset.targetColor || '',
                target_variant_id: String(targetVariant.id),
                selected_size: size
              });
            }
            window.location.assign(section.dataset.cartUrl);
          } catch (error) {
            status.textContent = section.dataset.errorLabel;
            button.disabled = false;
            button.textContent = originalLabel;
            if (croTreatment) {
              publish('pdp_color_bundle_add_error', {
                product_handle: section.dataset.currentHandle || '',
                target_product_handle: button.dataset.targetHandle || '',
                target_color: button.dataset.targetColor || '',
                target_variant_id: String(targetVariant.id),
                selected_size: size,
                reason: 'request_failed'
              });
            }
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
